import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { summaryMappingAtom } from './atoms'
import { Box, Button } from '@mui/material'
import React, { useMemo } from 'react'
import { Table } from 'shared/ui/Table/Table'
import { Column } from 'shared/ui/Table/types'
import { SummaryData } from './types'
import { useOpenAdminColumn, useOpenKiddomColumn } from './hooks'
import { atom } from 'infrastructure/state/jotai.wrapper'

const showTableAtom = atom(false)

export function Done() {
  return (
    <Box>
      <IsOpenToggle />
      <DoneTable />
    </Box>
  )
}

function IsOpenToggle() {
  const [isOpen, toggleOpen] = useAtom(showTableAtom)
  const mappings = useAtomValue(summaryMappingAtom)
  if (isOpen || !mappings) return null
  return (
    <Box>
      <Button
        color="inherit"
        variant="outlined"
        onClick={() => toggleOpen(!isOpen)}
      >
        <strong>Done:</strong> {Object.entries(mappings.done).length}
      </Button>
    </Box>
  )
}

function useColumns(): Column<[string, SummaryData[]]>[] {
  const openKiddom = useOpenKiddomColumn()
  const openAdmin = useOpenAdminColumn()
  return useMemo(() => {
    return [openKiddom, openAdmin]
  }, [openKiddom, openAdmin])
}

function DoneTable() {
  const [isOpen, toggleTable] = useAtom(showTableAtom)
  const mappings = useAtomValue(summaryMappingAtom)
  const columns = useColumns()
  const items = useMemo(() => {
    if (!mappings) return
    return Object.entries(mappings.done)
  }, [mappings])
  if (!items || !isOpen) return null
  return (
    <Table
      columns={columns}
      title={`Done: ${items.length}`}
      items={items}
      overrideHeight={200}
      toolBarItems={[
        <Button key="hideTable" onClick={() => toggleTable(false)}>
          Hide Table
        </Button>,
      ]}
    />
  )
}
